/**
 * @generated SignedSource<<cdb056ea439659e27cc8d8f3b0dee427>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GetHelpZendeskSellerItem_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"GetHelpZendeskBrowseByTopic_viewer" | "GetHelpZendeskSellerItemTile_viewer" | "GetHelpZendeskSellerPopularArticles_viewer">;
  readonly " $fragmentType": "GetHelpZendeskSellerItem_viewer";
};
export type GetHelpZendeskSellerItem_viewer$key = {
  readonly " $data"?: GetHelpZendeskSellerItem_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"GetHelpZendeskSellerItem_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GetHelpZendeskSellerItem_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "GetHelpZendeskSellerItemTile_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "GetHelpZendeskBrowseByTopic_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "GetHelpZendeskSellerPopularArticles_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "149457adcab8c211ee6b412edd5c67cc";

export default node;
